import { createContext } from "react";

export interface StrongAuthModalSubmitData {
  password?: string;
  googleSsoToken?: string;
  askForBypassMfa?: boolean;
}

export interface StrongAuthModalConfig {
  onSubmit: (data: StrongAuthModalSubmitData) => Promise<{ error: { code: string; message?: string } } | null>;
  onCancel: () => void;
}

export interface StrongAuthContextProps {
  isOpen: boolean;
  config: StrongAuthModalConfig | null;
  openStrongAuthModal: (config: StrongAuthModalConfig) => void;
  closeStrongAuthModal: () => void;
}

export const StrongAuthContext = createContext<StrongAuthContextProps>({
  isOpen: false,
  config: null,
  openStrongAuthModal: () => {},
  closeStrongAuthModal: () => {},
});
